<template>
  <div class="reviews">
    <h2 class="reviews__title">Отзывы</h2>
    <div class="reviews__slider">
      <VSlickCarousel
        v-bind="slickOptions"
        @afterChange="setSlideNum($event)"
        ref="slickEl"
      >
        <div
          class="review"
          v-for="(review, reviewIndex) in reviews"
          :key="reviewIndex"
        >
          <div class="review__photo">
            <img
              :src="
                require('../assets/img/reviews/photo-' + review.id + '.png')
              "
              alt=""
            />
          </div>
          <div class="review__text">
            <img class="_bg" src="../assets/img/reviews/text-bg.svg" alt="" />
            <div>
              {{ review.text }}
            </div>
          </div>
        </div>
      </VSlickCarousel>
    </div>
    <div class="slider-dots-wrap">
      <div class="slider-dots">
        <img
          class="slider-dots__arrow --left"
          src="../assets/img/slider-arrow-left.svg"
          alt=""
          @click="moveSlider('left')"
        />
        <img
          class="slider-dots__arrow --right"
          src="../assets/img/slider-arrow-right.svg"
          alt=""
          @click="moveSlider('right')"
        />

        <span
          v-for="(review, reviewIndex) in reviews"
          :key="reviewIndex"
          :class="{
            'slider-dots__dot': true,
            '--active': activeSlide == reviewIndex + 1,
          }"
          @click="changeSlide(reviewIndex + 1)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import "v-slick-carousel/style.css"
import { VSlickCarousel } from "v-slick-carousel"

const REVIEWS = [
  {
    id: 1,
    text: "Если начинаю хрустеть, то уже не могу оторваться. Есть только один минус: быстро заканчиваются",
  },
  {
    id: 2,
    text: "Случайно взял в дорогу. Теперь всё время беру. Очень вкусные, разные вкусы!",
  },
  {
    id: 3,
    text: "Вот честно, эти крекеры с пиццей какие-то дивные. Похоже, они прямо изобрели пиццу в виде крекеров. Идеальная закуска для просмотра футбольного матча или шоу",
  },
  {
    id: 4,
    text: "Очень вкусные крекеры. Покупаю теперь вместо чипсов. Хрустят также, и вкус ярче. Для перекусов подходит, поместится в любую сумку.",
  },
]

export default {
  name: "IndexReviews",
  components: { VSlickCarousel },
  data() {
    return {
      slickOptions: {
        slidesToShow: 3,
        arrows: false,
        centerMode: true,
        centerPadding: "0%",
        responsive: [
          {
            breakpoint: 960,
            settings: {
              centerPadding: "20%",
            },
          },
          {
            breakpoint: 1200,
            settings: {
              centerPadding: "25%",
            },
          },
        ],
      },
      activeSlide: 1,
    }
  },
  computed: {
    reviews() {
      return REVIEWS
    },
  },
  methods: {
    setSlideNum(activeSlide) {
      this.activeSlide = activeSlide + 1
    },
    changeSlide(slideNum) {
      this.$refs["slickEl"].goTo(slideNum - 1)
    },
    moveSlider(side) {
      if (side == "left") {
        this.changeSlide(this.activeSlide - 1)
      } else {
        this.changeSlide(this.activeSlide + 1)
      }
    },
  },
}
</script>

<style lang="scss">
.v-slick-slide-group {
  align-items: center;
}
.reviews {
  background-color: $color-blue;
  padding: 86px 0 106px;
  overflow: hidden;
  &__title {
    @include title();
    font-size: 11.2rem;
    color: white;
  }
  &__slider {
    margin: 84px 0 0;
  }
}
.review {
  position: relative;
  padding-left: 235px;
  width: 491px;
  &__photo {
    position: absolute;
    z-index: 0;
    left: 0;
    top: -14px;
    img {
      width: 295px;
    }
    pointer-events: none;
  }
  &__text {
    pointer-events: none;
    width: 256px;
    height: 343px;
    font-family: $font-text;
    font-size: 2rem;
    color: $color-blue;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 36px;
    ._bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 256px;
      z-index: 0;
    }
    > div {
      position: relative;
      z-index: 1;
      max-width: 180px;
    }
  }
  @include respond-to("smartphone-plus") {
    padding-left: 157px;
    width: 328px;
    .review__photo {
      img {
        width: 197px;
      }
    }
    .review__text {
      width: 171px;
      height: 229px;
      font-family: $font-text;
      font-size: 1.3rem;
      padding: 0 24px;
      ._bg {
        width: 171px;
      }
    }
  }
}

.slider-dots-wrap {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.slider-dots {
  height: 18px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 100px;
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  gap: 8px;
  &__dot {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    background-color: $color-blue;
    cursor: pointer;
    &.--active {
      background-color: #ffe671;
    }
  }
  &__arrow {
    position: absolute;
    transform: translate(0, -50%);
    width: 48px;
    top: -220px;
    cursor: pointer;
    &.--left {
      left: calc(-48px - 10px - 250px);
    }
    &.--right {
      right: calc(-48px - 10px - 250px);
    }
    @media screen and (min-width: 1500px) {
      &.--left {
        left: calc(-48px - 10px - 350px);
      }
      &.--right {
        right: calc(-48px - 10px - 350px);
      }
    }
  }
}

@include respond-to("smartphone-plus") {
  .slider-dots__arrow {
    display: block;
  }
  .slider-dots {
    &__arrow {
      top: 50%;
      &.--left {
        left: calc(-48px - 10px);
      }
      &.--right {
        right: calc(-48px - 10px);
      }
    }
  }
  .reviews {
    padding: 97px 0 149px;
    border-radius: 48px 48px 0 0;
    margin-top: -48px;
    &__title {
      font-size: 4.8rem;
    }
  }
}
</style>
